package com.gsb.vyapar.bhagya.presentation.searchlist.uistate

import com.gsb.vyapar.bhagya.domain.Business
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.updateState

data class SearchListUiState(
    val title: String = "SearchList",
    val searchBusinessList: List<Business> = listOf(),
) {
    fun updateSearchListTitleAndList(title: String, searchBusinessList: List<Business>) {
        updateSearchListUiState(this.copy(title = title, searchBusinessList = searchBusinessList))
    }
}

fun updateSearchListUiState(searchListUiState: SearchListUiState) {
    updateState(getState().copy(searchListUiState = searchListUiState))
}

fun getSearchListUiState(): SearchListUiState {
    return getState().searchListUiState
}